module.exports = "/_next/static/resources/life1-4bd7a0e4bc11f9e67cb6ec9a8d7a3527.jpg";